"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Tooltip;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Positioner = _interopRequireDefault(require("../Positioner"));

var _Card = _interopRequireDefault(require("../Card"));

var _Typography = require("../Typography");

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TooltipEl = _react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return _react["default"].createElement(_Card["default"], _extends({
    ref: ref,
    bg: "blue.900",
    borderRadius: 4,
    py: 2,
    px: 3
  }, props), _react["default"].createElement(_Typography.Text, {
    color: "white"
  }, children));
});

var _StyledTooltipEl = (0, _styledComponents["default"])(TooltipEl).withConfig({
  displayName: "Tooltip___StyledTooltipEl",
  componentId: "sc-29b7qg-0"
})(["", ""], function (p) {
  return p._css;
});

function Tooltip(_ref2) {
  var content = _ref2.content,
      children = _ref2.children,
      position = _ref2.position,
      props = _objectWithoutProperties(_ref2, ["content", "children", "position"]);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var targetRef = _react["default"].useRef();

  var handleMouseOver = function handleMouseOver() {
    return setOpen(true);
  };

  var handleMouseOut = function handleMouseOut() {
    return setOpen(false);
  };

  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].cloneElement(children, {
    onMouseOver: handleMouseOver,
    onMouseOut: handleMouseOut,
    ref: targetRef
  }), _react["default"].createElement(_Positioner["default"], {
    isShown: open,
    position: position,
    target: targetRef.current,
    offset: 4
  }, function (_ref3) {
    var ref = _ref3.ref,
        style = _ref3.style,
        state = _ref3.state,
        css = _ref3.css,
        zIndex = _ref3.zIndex;
    return _react["default"].createElement(_StyledTooltipEl, {
      ref: ref,
      style: style,
      "data-state": state,
      zIndex: zIndex,
      _css: css
    }, content);
  }));
}

;
Tooltip.propTypes = {
  content: _propTypes["default"].any.isRequired,
  children: _propTypes["default"].node.isRequired,
  position: _propTypes["default"].oneOf([_constants.Position.TOP, _constants.Position.TOP_LEFT, _constants.Position.TOP_RIGHT, _constants.Position.LEFT, _constants.Position.RIGHT, _constants.Position.BOTTOM, _constants.Position.BOTTOM_LEFT, _constants.Position.BOTTOM_RIGHT])
};
Tooltip.defaultProps = {
  position: _constants.Position.BOTTOM
};